"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pino_1 = __importDefault(require("pino"));
const util_1 = require("./util");
exports.initializeLogger = () => {
    // best way to check if we're in node
    if (util_1.isNode() && !util_1.isWallaby()) {
        util_1.checkLogDirectory();
    }
    // TODO:  figure out a proper way to store this
    const logger = pino_1.default({
        level: "debug",
        prettyPrint: {
            colorize: true,
            levelFirst: true,
        },
    });
    return logger;
};
exports.logger = exports.initializeLogger();
exports.getLogger = (file) => {
    if (!exports.logger) {
        throw new Error(`Logger was not initialized. Make sure to call initializeLogger!`);
    }
    const childLogger = exports.logger.child({ file });
    return {
        debug: util_1.logMethod(childLogger, "debug"),
        error: util_1.logMethod(childLogger, "error"),
        info: util_1.logMethod(childLogger, "info"),
        warn: util_1.logMethod(childLogger, "warn"),
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxnREFBdUI7QUFDdkIsaUNBTWU7QUFFRixRQUFBLGdCQUFnQixHQUFHLEdBQUcsRUFBRTtJQUNqQyxxQ0FBcUM7SUFDckMsSUFBSSxhQUFNLEVBQUUsSUFBSSxDQUFDLGdCQUFTLEVBQUUsRUFBRTtRQUMxQix3QkFBaUIsRUFBRSxDQUFBO0tBQ3RCO0lBRUQsK0NBQStDO0lBQy9DLE1BQU0sTUFBTSxHQUFHLGNBQUksQ0FBQztRQUNoQixLQUFLLEVBQUUsT0FBTztRQUNkLFdBQVcsRUFBRTtZQUNULFFBQVEsRUFBRSxJQUFJO1lBQ2QsVUFBVSxFQUFFLElBQUk7U0FDbkI7S0FDSixDQUFDLENBQUE7SUFDRixPQUFPLE1BQU0sQ0FBQTtBQUNqQixDQUFDLENBQUE7QUFDWSxRQUFBLE1BQU0sR0FBRyx3QkFBZ0IsRUFBRSxDQUFBO0FBUzNCLFFBQUEsU0FBUyxHQUFHLENBQUMsSUFBWSxFQUFVLEVBQUU7SUFDOUMsSUFBSSxDQUFDLGNBQU0sRUFBRTtRQUNULE1BQU0sSUFBSSxLQUFLLENBQ1gsaUVBQWlFLENBQ3BFLENBQUE7S0FDSjtJQUVELE1BQU0sV0FBVyxHQUFHLGNBQU0sQ0FBQyxLQUFLLENBQUMsRUFBQyxJQUFJLEVBQUMsQ0FBQyxDQUFBO0lBQ3hDLE9BQU87UUFDSCxLQUFLLEVBQUUsZ0JBQVMsQ0FBQyxXQUFXLEVBQUUsT0FBTyxDQUFDO1FBQ3RDLEtBQUssRUFBRSxnQkFBUyxDQUFDLFdBQVcsRUFBRSxPQUFPLENBQUM7UUFDdEMsSUFBSSxFQUFFLGdCQUFTLENBQUMsV0FBVyxFQUFFLE1BQU0sQ0FBQztRQUNwQyxJQUFJLEVBQUUsZ0JBQVMsQ0FBQyxXQUFXLEVBQUUsTUFBTSxDQUFDO0tBQ3ZDLENBQUE7QUFDTCxDQUFDLENBQUEifQ==